// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { scheduleReminderModalStyles } from "@insite/content-library/Components/ScheduleReminderModal";
import { GridOffset } from "@insite/mobius/GridContainer";
import { RadioStyle } from "@insite/mobius/Radio";
import { mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

scheduleReminderModalStyles.frequencyRadioGroup = {
    css: css`
        display: block;
        legend {
            margin-bottom: 0;
        }
        & > ${RadioStyle} {
            display: inline-block;
            margin-top: 0;
        }
    `,
};

scheduleReminderModalStyles.startDateGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
        align-items: initial;
        &&&& .react-datetime-picker__clear-button.react-datetime-picker__button {
            padding-right: 0;
        }
        &&&&.hide-clear-button .react-datetime-picker__clear-button {
            display: none;
        }
    `,
};

scheduleReminderModalStyles.startDatePicker = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
    calendarIconProps: {
        css: css`
            width: 28px !important;
            padding: 8px 4px !important;
        `,
    },
    clearIconProps: {
        css: css`
            width: 28px !important;
            padding: 8px 4px !important;
        `,
    },
};

scheduleReminderModalStyles.endDateGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
        align-items: initial;
        &&&& .react-datetime-picker__clear-button.react-datetime-picker__button {
            padding-right: 0;
        }
    `,
};

scheduleReminderModalStyles.endDatePicker = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
    calendarIconProps: {
        css: css`
            width: 28px !important;
            padding: 8px 4px !important;
        `,
    },
    clearIconProps: {
        css: css`
            width: 28px !important;
            padding: 8px 4px !important;
        `,
    },
};

scheduleReminderModalStyles.buttonsContainer = {
    ...mergeWithCss(scheduleReminderModalStyles.buttonsContainer, {
        css: css`
        & ${GridOffset} {
                ${xScreen("lte", "xs")} {
                    flex-direction: column-reverse;
                }
            }
        `,
    }),
}

scheduleReminderModalStyles.middleRowLeftColumnGridItem = scheduleReminderModalStyles.middleRowRightColumnGridItem = {
    width: 12,
}